import { render, staticRenderFns } from "./add_or_edit.vue?vue&type=template&id=3a922eaa&scoped=true&"
import script from "./add_or_edit.vue?vue&type=script&lang=js&"
export * from "./add_or_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a922eaa",
  null
  
)

export default component.exports